import axios from 'axios';
import { API_BASE_URL, DEFAULT_HEADERS } from './config';
import { getCsrfHeaders, applyCsrfFromResponse, getCsrfToken, recoverCsrfToken } from './csrf';

export const SESSION_EXPIRED_EVENT = 'auth:session-expired';

let isRefreshing = false;
let refreshQueue = [];

const processRefreshQueue = (error) => {
  refreshQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  refreshQueue = [];
};

export const dispatchSessionExpired = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
  }
};

export const refreshAccessToken = async () => {
  if (!getCsrfToken()) {
    await recoverCsrfToken();
  }

  const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {}, {
    withCredentials: true,
    headers: {
      ...DEFAULT_HEADERS,
      ...getCsrfHeaders(),
    },
  });

  if (response?.data?.data) {
    applyCsrfFromResponse(response.data.data);
  }

  return response;
};

export const refreshSessionWithQueue = async () => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      refreshQueue.push({ resolve, reject });
    });
  }

  isRefreshing = true;

  try {
    await refreshAccessToken();
    processRefreshQueue(null);
  } catch (error) {
    processRefreshQueue(error);
    throw error;
  } finally {
    isRefreshing = false;
  }
};

const parseAccessTokenLifetimeMs = () => {
  const expiry = process.env.REACT_APP_JWT_ACCESS_EXPIRES_IN || '15m';
  const match = String(expiry).match(/^(\d+)([smhd])$/);
  if (!match) {
    return 15 * 60 * 1000;
  }
  const value = parseInt(match[1], 10);
  const unit = match[2];
  const multipliers = { s: 1000, m: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };
  return value * multipliers[unit];
};

export const getProactiveRefreshIntervalMs = () => {
  const lifetime = parseAccessTokenLifetimeMs();
  const buffer = Math.min(60 * 1000, Math.floor(lifetime * 0.1));
  return Math.max(lifetime - buffer, 60 * 1000);
};
